import { http } from 'connex-cds';

export default {
  listTemplates: ({ entityRef, queryParams }) =>
    http.get({ apiName: 'company-admin', path: `/${entityRef}/pdf-ticket-report`, queryParams }),
  importTicket: ({ entityRef, data }) =>
    http.post({ apiName: 'company-admin', path: `/${entityRef}/pdf-ticket-report/import-ticket`, data }),
};
